<!--
  - Placeholder label.
-->
<label
    *ngIf="!displayAsText && !displayAsTag && !lmParagraphLayoutInfo"
    [ngClass]="{'label lm-placeholder-label no-colon' : true, 'lm-no-label': lmColumnLayoutInfo?.isTable}"
>&nbsp;</label>

<label *ngIf="label"
   soho-label
   [required]="required$ | async"
   lm-label
   [layoutField] = "field">
  {{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}
</label>
<ng-container [ngSwitch]="displayType">
  <ng-container *ngSwitchCase="layoutDisplayType.DISPLAY_AS_CHECKBOXES">
    <div class="lm-checkbox-group-wrapper"
      attr.aria-labelledby="{{id}}"
      [attr.tabindex]="isInAccessibilityMode && (readOnly$ | async) ? 0 : null">
      <ng-template ngFor let-item [ngForOf]="values$ | async" [ngForTrackBy]="trackByValue" let-indx="index">
        <ng-container *ngIf="(item && item.label != ' ') && !displayAsText">
          <input
            type="checkbox"
            class="checkbox"
            attr.data-val="{{item.value}}"
            attr.id="{{id}}_{{indx}}_Option"
            name="{{id}}_{{indx}}_Option"
            attr.name="{{id}}_{{indx}}_Option"
            [attr.bindId]="bindId"
            [attr.disabled]="(readOnly$ | async) ? true : null"
            (click)="selectItem(item)"
            soho-checkbox
            [(ngModel)]="item.selected"
            soho-alert
            soho-input-validate
              (error)="onError($event)"
              (valid)="onValid($event)"
              (focus)="onFocus($event)"
              (blur)="onBlur($event)">
          <label
            soho-label
            attr.for="{{id}}_{{indx}}_Option"
            class="lm-checkbox-label"
          >
            {{item?.label}}
          </label>
          <br *ngIf="!isHorizontal && indx != ((values$ | async).length - 1)"/>
        </ng-container>
      </ng-template>
    </div>
  </ng-container>
</ng-container>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
